var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"title":_vm.$tc('share.copy'),"href":_vm.twitterShareLink,"target":"_blank"},on:{"click":_vm.onTwitterShare}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""}},[_vm._v(" mdi-twitter ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }